{
  "privacy": {
    "title": "개인정보 처리방침",
    "paragraphs": [
      "적힌대로는 계정 없이 작동해요. 업체명·구조화 견적·항목별 압축 사진·회신·체크·현재 합의·열린 후속·취소·연기 통지 원문·정산·영수증 상태·이사 후 사실·청소 회차는 이 기기의 IndexedDB에만 둬요. 내 데이터에서 전체 JSON 백업을 받거나 즉시 삭제할 수 있고, 계약 마감 화면은 사람이 읽는 PDF로 따로 보관할 수 있어요. 사진은 브라우저에서 WebP로 줄이고 촬영정보를 제거하며 서버로 보내지 않아요.",
      "서비스 개선 통계에는 이벤트 이름·시각과 계약 종류·상태·개수 구간처럼 허용한 값만 보내요. 견적 원문·통지 원문·정산 금액·관찰 사실·회신 메모·업체명·사진·주소·전화번호·프로젝트 식별자는 보내지 않으며, Cloudflare Workers Analytics Engine에서 최대 3개월 보관해요.",
      "자동 분석은 현재 비활성이에요. 활성화하면 사용자가 편집한 가림 영역을 새 이미지로 다시 그려 원본과 EXIF를 제거한 byte만 Cloudflare Workers AI에 전송해요. OCR 텍스트는 주소·전화번호 패턴을 지운 뒤 구조화하고, 그 구조화 결과만 중복 요청 방지를 위해 최대 24시간 보관해요. 자동 분석용 전체 사진은 이 기기의 기록에도 보관하지 않아요. 입력과 결과는 별도 동의 없이 모델 학습에 쓰지 않아요.",
      "대화 파일·PDF·캡처 사진과 한국어 글자 인식은 기기 안에서만 처리해요. 파일과 글자를 서버로 보내지 않으며, 대화 파일은 사용자가 고른 사람의 메시지만 전화번호·주소 형태를 가린 뒤 저장해요. 글자 인식 프로그램과 한국어 자료는 처음 사용할 때 같은 출처에서 내려받아요.",
      "화면·익명 이벤트·쿠키 없는 방문 분석은 Cloudflare(미국 회사) 인프라에서 처리돼요. 구글 캘린더 추가를 누르면 일정 제목과 날짜가 구글로 전달돼요. 적힌대로 서버는 거치지 않아요.",
      "자동 분석에는 Cloudflare Turnstile 보안 확인과 식별 불가능하게 HMAC 처리한 일일 요청 횟수 제한을 사용해요. 운영자: MUNOPS · 기준 확인일: 2026-09-01 · 열람·삭제·오류 문의는 아래 공개 문의 주소로 보내 주세요."
    ]
  },
  "terms": {
    "title": "이용약관",
    "paragraphs": [
      "적힌대로는 이사·청소 계약에 무엇이 적혀 있는지 확인하고 사실 확인 요청, 현재 합의, 취소·연기 통지 원문, 실제 정산·영수증 상태, 이사·청소 당일 확인, 열린 후속, 이사 후 사실 묶음과 청소 회차 비교를 만드는 도구예요. 적정 가격, 위법 여부, 위약금, 원인·귀책·배상 책임, 분쟁 결과를 판단하거나 업체를 추천·중재·대리하지 않아요.",
      "자동으로 찾은 항목과 생성 문장은 틀릴 수 있어요. 사용자는 계약 원문과 생성 문장을 직접 확인하고 고친 뒤 업체와의 합의에 사용해야 해요. 계약 마감에는 실제로 받은 통지와 오간 금액만 남기고 계좌번호·카드번호를 입력하지 않아야 해요.",
      "지금 제공하는 안 적힘 목록, 요청 문장 복사, PDF 보관, 견적 비교, 현재 합의·당일·후속 기록, 취소·연기와 정산·영수증 기록, 이사 후 사실, 청소 회차 기록과 데이터 내보내기·복구는 모두 무료예요. 별도 보관 파일은 판매 전 후보이며 결제 기능은 제공하지 않아요. 환불 규정은 판매 시작 전 별도 확정해 안내해요.",
      "나중에 무료 기능과 분리된 새 유료 실물이 생기더라도 기존 기록의 읽기·내보내기·삭제 권리를 거두지 않아요. 가격·제공 내용·환불·복원 조건과 별도 동의를 갖춘 새 계약을 검증하기 전에는 구매 화면을 열지 않아요.",
      "보안·장애·법령 변경 때문에 기능을 잠시 제한할 수 있으며, 이때 저장한 로컬 기록은 내 데이터에서 먼저 내보낼 수 있도록 안내해요."
    ]
  },
  "support": {
    "title": "도움말·문의",
    "paragraphs": [
      "문서 항목 오류, 데이터 삭제, 접근성, 결제 문제 중 무엇인지와 사용한 화면을 알려 주세요. 견적 원문·통지 원문·정산 금액·관찰 사실·회신 메모·항목 사진·주소·전화번호·결제정보는 이메일에 넣지 마세요.",
      "3영업일 안에 확인하는 것을 목표로 해요. 적힌대로는 업체와의 분쟁을 대신 접수하거나 교섭하지 않아요.",
      "소비자 상담이 필요하면 1372 소비자상담센터나 한국소비자원 공식 경로를 이용해 주세요."
    ]
  }
}
